import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=57e56d11&scoped=true&"
import script from "./EditProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=57e56d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e56d11",
  null
  
)

export default component.exports